import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { SimpleModalComponent } from "ngx-simple-modal";
import { SchedulerListService } from "@nms-ng2/app/modules/scheduler/scheduler-list/scheduler-list.service";
import { NmsWizardComponent, NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { JobType, SchedulerJob } from "@nms-ng2/app/modules/scheduler/scheduler.models";
import { SchedulerService } from "@nms-ng2/app/modules/scheduler/scheduler.service";
import { DeviceBackupUtilsService } from "../device-backup-utils.service";
import { BackupJobModal } from "../device-backup.models";

/**
 * Modal para criação de backups de Equipamentos.
 */
@Component({
    selector: "create-backup-modal",
    templateUrl: "./create-backup-modal.component.html",
    styleUrls: ["./create-backup-modal.component.scss"]
})
export class CreateBackupModalComponent extends SimpleModalComponent<BackupJobModal, any>
implements AfterViewInit, BackupJobModal {
    schedulerJob: SchedulerJob
    isEdit: boolean;
    @ViewChild(NmsWizardComponent)
    nmsWizard: NmsWizardComponent;
    isLoading: boolean = true;
    wizardStepsCacheMap: NmsWizardStepMapData = {};

    constructor(private schedulerListService: SchedulerListService,
                private schedulerService: SchedulerService,
                private deviceBackupUtils: DeviceBackupUtilsService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
        this.schedulerListService.closeModalEmmiter.subscribe(() => this.close());
    }

    async ngAfterViewInit(): Promise<void> {
        this.isLoading = true;

        try {
            this.isEdit = !!this.schedulerJob;

            const schedulerJob = this.schedulerService.initSchedulerJob(this.schedulerJob, JobType.BACKUP);

            if (this.isEdit) {
                this.wizardStepsCacheMap = await this.deviceBackupUtils.fillTabsData(schedulerJob);
            } else {
                this.wizardStepsCacheMap = await this.deviceBackupUtils.initDefaultValues(schedulerJob);
            }
        } finally {
            this.isLoading = false;
        }
    }

    ngAfterViewChecked(): void {
        this.changeDetectorRef.detectChanges();
    }

    cancel(): void {
        this.close();
    }
}
